import { FlexColumn } from '@elementary/common-ui/components';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { fontSize, space } from '@elementary/common-ui/style/utils';
import { Role } from '../shared/types';

const RoleItem = ({
  name,
  description,
}: {
  name: string;
  description?: string | null;
}) => (
  <FlexColumn sx={{ gap: space('sm') }}>
    <Typography>{name}</Typography>
    <Typography sx={{ color: 'content.secondary', fontSize: fontSize('sm') }}>
      {description}
    </Typography>
  </FlexColumn>
);

const RoleSelectFormField = ({ roles }: { roles?: Role[] }) => {
  const methods = useFormContext();

  return (
    <FormControl>
      <InputLabel shrink>Role</InputLabel>
      <Controller
        control={methods.control}
        name="role_id"
        render={({ field }) => (
          <Select
            {...field}
            onChange={(event) => {
              if (event.target.value === '') {
                field.onChange(null);
              } else {
                field.onChange(event.target.value);
              }
            }}
            notched
            label="Role"
            renderValue={(role_id: string | null) =>
              role_id === '' || role_id === null
                ? 'No role'
                : roles?.find((role) => role.id === role_id)?.name
            }
            displayEmpty
          >
            <MenuItem key="no-role" value="">
              <RoleItem
                name="No role"
                description="No permissions will be assigned to this user."
              />
            </MenuItem>
            {roles?.map((role) => (
              <MenuItem key={role.id} value={role.id}>
                <RoleItem name={role.name} description={role.description} />
              </MenuItem>
            ))}
          </Select>
        )}
      />
    </FormControl>
  );
};
export default RoleSelectFormField;
